export default __webpack_public_path__ + "static/media/trincheta-sello-nuevo-transparent.1d550893.png";